"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtExternalLink = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtExternalLink = function SvgBtExternalLink(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.79 8.933a2.427 2.427 0 011.781-.74h6.286c.072 0 .127.022.17.065h0a.228.228 0 01.066.17V9a.228.228 0 01-.066.17.228.228 0 01-.17.066H8.571c-.406 0-.755.145-1.044.434-.289.289-.434.638-.434 1.044v7.429c0 .406.145.755.434 1.044h0c.29.289.638.434 1.044.434H16c.406 0 .755-.145 1.044-.434l-.035-.036.035.036c.29-.29.434-.638.434-1.044v-2.857c0-.072.023-.127.066-.17h0a.227.227 0 01.17-.066h.572c.071 0 .127.022.17.066h0a.228.228 0 01.066.17v2.857c0 .695-.247 1.288-.74 1.781h0a2.427 2.427 0 01-1.782.74H8.571a2.427 2.427 0 01-1.781-.74l-.036.035.036-.035a2.427 2.427 0 01-.74-1.781v-7.429c0-.695.246-1.288.74-1.781zm0 0l-.036-.036m.036.036l-.036-.036m0 0a2.477 2.477 0 011.817-.754h6.286c.084 0 .152.027.206.08l-8.309.674z",
    fill: "currentColor",
    stroke: "#fff",
    strokeWidth: 0.1
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.49 7.205h0a.5.5 0 01.367-.155h4.571a.5.5 0 01.367.155.5.5 0 01.155.366v4.572c0 .14-.05.262-.155.366a.5.5 0 01-.367.155.5.5 0 01-.366-.155h0l-1.571-1.571-.036-.036-.035.036-5.822 5.821h0a.232.232 0 01-.17.075.232.232 0 01-.17-.075l-.035.036.035-.036-1.017-1.018a.232.232 0 010-.34h0l5.821-5.821.035-.035-.035-.036-1.571-1.571a.5.5 0 01-.155-.367.5.5 0 01.155-.366z",
    fill: "currentColor",
    stroke: "#fff",
    strokeWidth: 0.1
  }));
};

exports.SvgBtExternalLink = SvgBtExternalLink;